import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    // 外层容器
    wrapper: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    // 显示容器
    container: {
        flexDirection: 'row',
        alignItems: 'baseline',
    },
    // 纯展示模式容器（支持原价显示）
    displayContainer: {
        flexDirection: 'row',
        alignItems: 'baseline',
    },
    mainFont: {
        fontWeight: 'bold',
    },
    // 输入框容器
    inputContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: '#E5E5E5',
        borderRadius: 8,
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 8,
        minHeight: 40,
    },
    inputContainerFocused: {
        borderColor: '#007AFF',
        shadowColor: '#007AFF',
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.15,
        shadowRadius: 4,
        elevation: 2,
    },
    inputContainerDisabled: {
        backgroundColor: '#F5F5F5',
        borderColor: '#D9D9D9',
    },
    // 输入框
    input: {
        flex: 1,
        fontSize: 18,
        fontWeight: 'bold',
        color: '#333333',
        textAlign: 'center',
        paddingVertical: 8,
        minWidth: 60,
    },
    inputDisabled: {
        color: '#999999',
    },
    // 币种符号
    currencySymbol: {
        fontSize: 14,
        color: '#666666',
        marginRight: 2,
    },
    // 步进器按钮
    stepperButton: {
        width: 32,
        height: 32,
        borderRadius: 16,
        backgroundColor: '#F5F5F5',
        justifyContent: 'center',
        alignItems: 'center',
    },
    stepperButtonSmall: {
        width: 24,
        height: 24,
        borderRadius: 12,
    },
    stepperButtonLarge: {
        width: 40,
        height: 40,
        borderRadius: 20,
    },
    stepperButtonPressed: {
        backgroundColor: '#E0E0E0',
    },
    stepperButtonDisabled: {
        opacity: 0.4,
    },
    stepperIcon: {
        fontSize: 18,
        color: '#333333',
        fontWeight: '500',
    },
    stepperIconSmall: {
        fontSize: 14,
    },
    stepperIconLarge: {
        fontSize: 22,
    },
    // 金额显示区域
    amountWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 12,
    },
    // 分隔符
    separator: {
        width: 8,
    },
});

// 获取步进器按钮样式
export const getStepperButtonStyle = (size: 'small' | 'medium' | 'large') => {
    switch (size) {
        case 'small':
            return styles.stepperButtonSmall;
        case 'large':
            return styles.stepperButtonLarge;
        default:
            return {};
    }
};

// 获取步进器图标样式
export const getStepperIconStyle = (size: 'small' | 'medium' | 'large') => {
    switch (size) {
        case 'small':
            return styles.stepperIconSmall;
        case 'large':
            return styles.stepperIconLarge;
        default:
            return {};
    }
};
